import removeMultipleSpaces from "@mobi/utils/formatters/removeMultipleSpaces";
export var handleChange = function handleChange(event, field, changeMethod) {
  field.onChange(event);
  changeMethod(event);
};
export var handleBlur = function handleBlur(event, field, blurMethod) {
  field.onBlur();
  var clearEvent = Object.assign({}, event, {
    target: Object.assign({}, event.target, {
      value: removeMultipleSpaces(field.value)
    })
  });
  if (field.value !== clearEvent.target.value) {
    field.onChange(clearEvent);
  }
  if (blurMethod) {
    blurMethod(clearEvent);
  }
};